module.exports = __webpack_public_path__ + "static/media/image3.c1f26b24.png";